const ABBREVIATIONS = {
	AGRICOLA: "A.",
	AGRICOLAS: "A.",
	AGRÍCOLA: "A.",
	BALANZA: "B.",
	BODEGA: "B.",
	FUNDO: "F.",
	FRUTICOLA: "F.",
	FRUTÍCOLA: "F.",
	LIMITADA: "LTDA",
	AGROINVENTARIO: "AGRO.",
	PRINCIPAL: "P.",
	SOCIEDAD: "S.",
	ACTUALIZACION: "A.",
	ACTUALIZACIÓN: "A.",
	COOPERATIVA: "COOP.",
};

const EXCLUDED_WORDS = ["DE", "DEL", "LA", "LAS", "LOS", "EL", "Y"];

export const abbreviateName = (fullName) => {
	if (!fullName || typeof fullName !== "string") return "";

	const words = fullName.trim().split(/\s+/);
	const abbreviated = [];

	for (const word of words) {
		const upperWord = word.toUpperCase();

		if (ABBREVIATIONS[upperWord]) {
			abbreviated.push(ABBREVIATIONS[upperWord]);
		} else if (!EXCLUDED_WORDS.includes(upperWord)) {
			abbreviated.push(word.toUpperCase());
		}
	}

	return abbreviated.join(" ").trim();
};

export const formatNameWithTooltip = (fullName) => {
	return {
		abbreviated: abbreviateName(fullName),
		full: fullName || "",
	};
};
